import { Grid, Typography } from "@mui/material";
import {
  EditableDateInput,
  EditableTextInput,
  EditableBoolInput,
  EditableSelectInput,
  EditableDatetimeInput,
  EditableFileInput,
} from "../index";

function EditableInputDisplay({
  label,
  id,
  initialValue,
  inputMode,
  adornment,
  setEditMode,
  selectType,
  selectQueryKey,
  setParentValue,
  selectAllowEmpty = true,
}) {
  const switchInputMode = () => {
    switch (inputMode) {
      case "bool":
        return (
          <EditableBoolInput
            editMode={setEditMode}
            propsInitialValue={initialValue}
            inputMode={inputMode}
            inputId={id}
            setParentValue={setParentValue}
          />
        );
      case "date":
        return (
          <EditableDateInput
            editMode={setEditMode}
            propsInitialValue={initialValue}
            inputMode={inputMode}
            inputId={id}
            setParentValue={setParentValue}
          />
        );
      case "datetime":
        return (
          <EditableDatetimeInput
            editMode={setEditMode}
            propsInitialValue={initialValue}
            inputMode={inputMode}
            inputId={id}
            setParentValue={setParentValue}
          />
        );
      case "select":
        return (
          <EditableSelectInput
            editMode={setEditMode}
            propsInitialValue={initialValue}
            inputMode={inputMode}
            inputId={id}
            queryKey={selectQueryKey}
            type={selectType}
            setParentValue={setParentValue}
            selectAllowEmpty={selectAllowEmpty}
          />
        );
      case "image":
        return (
          <EditableFileInput
            editMode={setEditMode}
            propsInitialValue={initialValue}
            inputMode={inputMode}
            inputId={id}
            queryKey={selectQueryKey}
            type={selectType}
            setParentValue={setParentValue}
          />
        );
      default:
        return (
          <EditableTextInput
            editMode={setEditMode}
            propsInitialValue={initialValue}
            inputMode={inputMode}
            inputId={id}
            setParentValue={setParentValue}
            adornment={adornment}
          />
        );
    }
  };

  if (label !== null) {
    return (
      <Grid container sx={{ alignItems: "center" }}>
        <Grid item xs={6}>
          <Typography id={id}>
            <strong>{label}</strong>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          {switchInputMode()}
        </Grid>
      </Grid>
    );
  } else {
    return <>{switchInputMode()}</>;
  }
}

export default EditableInputDisplay;
